import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useAuthUserMutation } from '../slices/usersApiSlice';
import { setCredentials } from '../slices/authApiSlice';
import { toast } from 'react-toastify';
import FormContainer from '../components/FormContainer';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { isAuthCookieAccepted, COOKIES_REQUIRED_MESSAGE } from '../utils/authCookieCheck';


export default function UserSignInScreen() {
  const [primaryEmail, setPrimaryEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [signIn] = useAuthUserMutation();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const redirect = searchParams.get('redirect') || "/";

  const signInHandler = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const dbResponse = await signIn({ primaryEmail, password }).unwrap();
      if (!(await isAuthCookieAccepted())) {
        setLocalError(COOKIES_REQUIRED_MESSAGE);
        return;
      }
      dispatch(setCredentials({ ...dbResponse }));
      toast.success("Success: You have signed in");
      navigate(redirect);
    } catch (err) {
      const msg =
        err?.data?.message ||
        err.error ||
        'Error: Invalid e-mail or password';
      setLocalError(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormContainer>
      <h1 style={{ marginTop: '32px' }}>Sign In</h1>

      {localError && <Message variant="danger">{localError}</Message>}

      <Form onSubmit={signInHandler}>
        <Form.Group controlId="primaryEmail" className="my-4">
          <Form.Label>E-Mail Address:</Form.Label>
          <Form.Control
            type="email"
            placeholder="Primary e-mail address"
            value={primaryEmail}
            onChange={(e) => {
              if (localError) setLocalError('');
              setPrimaryEmail(e.target.value);
            }}
          />
        </Form.Group>

        <Form.Group controlId="password" className="my-4">
          <Form.Label>Password:</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              if (localError) setLocalError('');
              setPassword(e.target.value);
            }}
          />
        </Form.Group>

        <Button
          type="submit"
          variant="primary"
          className="my-2"
          disabled={isSubmitting}
        >
          Sign In
        </Button>

        {isSubmitting && <Loader />}
      </Form>

      <Row className="py-4">
        <Col>
          First visit?{' '}
          <Link
            to={
              redirect
                ? `/sign_up?redirect=${redirect}`
                : "/sign_up"
            }
          >
            Sign Up
          </Link>
        </Col>
      </Row>

      <Row className="py-0 mb-2">
        <Col>
          Forgot password?{' '}
          <Link
            to={
              redirect
                ? `/forgot_password?redirect=${redirect}`
                : "/forgot_password"
            }
          >
            Reset Password
          </Link>
        </Col>
      </Row>
    </FormContainer>
  );
}